"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slateToHtml = void 0;

var dom_serializer_1 = require("dom-serializer");

var dom_1 = require("@slate-serializers/dom");

var slateToHtml = function slateToHtml(node) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dom_1.slateToDomConfig;
  var document = (0, dom_1.slateToDom)(node, config);
  return (0, dom_serializer_1.default)(document, {
    encodeEntities: 'encodeEntities' in config ? config.encodeEntities : false
  });
};

exports.slateToHtml = slateToHtml;